import Vue from 'vue'
import Router from 'vue-router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import topicColumn from '@/page/topicColumn'
import topicColumnDetail from '@/page/topicColumnDetail'
import test from '@/page/test'

Vue.use(VueAwesomeSwiper)
Vue.use(Router)

let scrollY = ''

const scrollBehavior = (to, from, savedPosition) => {
  const position = {}
  if (to.name === 'topicColumn') {
    position.x = 0
    position.y = scrollY
    return position
  } else {
    // check if any matched route config has meta that requires scrolling to top
    if (to.matched.some(m => m.meta.scrollToTop)) {
      // cords will be used if no selector is provided,
      // or if the selector didn't match any element.
      position.x = 0
      position.y = 0
    }
    // if the returned position is falsy or an empty object,
    // will retain current scroll position.
    return position
  }
}

export default new Router({
  mode: 'history',
  scrollBehavior,
  routes: [
    {
      path: '/topicColumn/:sid/:topicID',
      name: 'topicColumn',
      component: topicColumn
    },
    {
      path: '/topicColumn/:sid/:topicID/:discussID',
      // path: '/topicColumn/topicColumnDetail/:discussID',
      name: 'topicColumnDetail',
      component: topicColumnDetail,
      beforeEnter (to, from, next) {
        scrollY = window.scrollY
        next()
      },
      meta: { scrollToTop: true }
    },
    {
      path: '/test',
      name: 'test',
      component: test
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js